export { createAuthRouteHandlers } from './route-handlers';
export type { AuthRouteConfig } from './route-handlers';
